module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0003.jpg?v=a0d6e9ca";